import React, { useState } from 'react'
import { Form } from 'antd'
import FormItem from '../Interactions/FormItem';
import MyInput from '../Interactions/MyInput';
import logo from "../../assets/logos/M3_Logo.png";
import { Link, useNavigate } from 'react-router-dom';
import GradientButton from '../Button/GradientButton';
import { LoadingOutlined, AppleFilled } from '@ant-design/icons';
import {  facebookIcon, googleIcon } from '../../utils/icons';
import toastMessage from '../../utils/toastMessage';
import signInAws from '../../utils/AWS/signinAws';
import MyPassword from '../Interactions/PasswordInput';
import LoginOtpModal from '../AllModal/LoginOtpModal';
import { setUserNameReducer } from '../../slices/authSlice';
import { useDispatch } from 'react-redux';

const inputStyle = {
    // placeholder: { color: '#fff', },
    // backgroundColor: '#C0C0C0',
}

const rules = [{ required: true, message: 'This field is required' }]

const LoginModal = ({ open, onOk, onCancel,  }) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [userCredentials, setUserCredentials] = useState({});
    const [isOtpSend, setIsOtpSend] = useState(false);
    const [otp, setOtp] = useState(false);

    const handleNavigateToSignUp = (e) => {
        onCancel();
        navigate("/signup");
    }

    const handleChildClick = (e) => {
        e.stopPropagation();
    };

    const callbackForLogin = (error, isLoggedIn, username) => {
        if(error){
            error = error === "Incorrect username or password." ? "Incorrect email or password" : error
            toastMessage(error, "error");
        }
        else {
            // toastMessage("Otp send to your registered email or phone", "info");
            // setIsOtpSend(true);
            // console.log(username, " = callbackForLogin");
            dispatch(setUserNameReducer({ username }));
            toastMessage("Successfully LoggedIn", "success");
            navigate("/");
            // localStorage.setItem("m3_accessToken", accessToken);
        }
        setIsLoading(false);
    }

    const handleFinish = (values) => {
        console.log(values, "valuesssssssss");
        const { email, password } = values;
        if(!email || !password) {
            toastMessage("Please provide Email and Password", "error");
            return;
        }
        setUserCredentials({ email: email, password: password })
        setIsLoading(true);
        signInAws(email, password, callbackForLogin);
    }

    if(!open) return;
  return (
    <>
        <LoginOtpModal
            open={isOtpSend} 
            onOk={()=>{}} 
            onCancel={()=>setIsOtpSend(false)} 
            email={userCredentials?.email}
            onEmailVerification={()=>navigate("/")}
        />    
        <div 
            className='fixed top-0 left-0 z-[999] bg-gray-700/90 h-screen pt-6 w-screen flex justify-center items-center overflow-y-auto' 
            onClick={onCancel}
        >
            <div onClick={handleChildClick} className="w-full flex flex-col justify-center items-center">
                <div className='modalConatainerBg w-[350px] sm:w-[500px] min-h-[520px] rounded-xl flex flex-col items-center'>
                    <div className='mt-12'>
                        <img src={logo} alt="logo" width={110} />
                    </div>
                    <div className='mt-10 mb-8'>
                        <p className="text-lg font-bold font-satoshi">Login</p>
                    </div>
                    <Form onFinish={handleFinish} form={form} className='w-full flex flex-col items-center'>
                        <FormItem className="w-[80%]" name="email" rules={rules}>
                            <MyInput placeholder="Email" style={inputStyle} />
                        </FormItem>
                        <FormItem className="w-[80%] mt-10" name="password" rules={rules}>
                            <MyPassword placeholder="Password" style={inputStyle} />
                        </FormItem>
                        <div className="w-[80%] flex justify-end mt-2">
                            <Link to="/forgot-password" className='text-lightOrange hover:text-darkOrange'>Forgot Password</Link>
                        </div>

                        <GradientButton disabled={isLoading} type="submit" className="px-12 rounded-xl mt-8 flex gap-x-4 items-center">
                            <span>Login</span>{isLoading && <LoadingOutlined />}
                        </GradientButton>
                    </Form>
                </div>
                <div className='w-[350px] sm:w-[500px] rounded-xl flex flex-col items-center'>
                    <div className="w-full flex justify-end mt-1 mr-2">
                        <p onClick={handleNavigateToSignUp} className='text-white hover:text-gray-200 cursor-pointer'>CREATE AN ACCOUNT</p>
                    </div>
                    <p className='text-white my-5'>CONNECT WITH OTHER WAYS</p>
                    <div className='w-full flex justify-center items-center gap-x-4'>
                        <div className='bg-white w-10 h-10 rounded-full flex justify-center items-center cursor-pointer'>{googleIcon}</div>
                        <div className='bg-white w-10 h-10 rounded-full flex justify-center items-center cursor-pointer'>{facebookIcon}</div>
                        <div className='bg-white w-10 h-10 rounded-full flex justify-center items-center cursor-pointer'><AppleFilled style={{ fontSize: 30, }} /></div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default LoginModal
